import request from "@/utils/request.js";

/**
 * 检查考场是否存在
 * @param params
 * @returns {AxiosPromise}
 */
export function getCheckTestingNumberIsExists(params) {
  return request({
    closeInterceptors: true,
    url:
      "/teachingPlatformService/api/app/testing/getCheckTestingNumberIsExists",
    method: "post",
    data: params
  });
}

/**
 * 获取考试须知
 * @param params
 * @returns {AxiosPromise}
 */
export function getTestInstructionsById(params) {
  return request({
    url: "/teachingPlatformService/api/app/testing/getTestInstructionsById",
    method: "post",
    data: params
  });
}

/**
 * 调用用户考试剩余时间
 * @param params
 * @returns {AxiosPromise}
 */
export function getUserTestingSurplusInfo(params) {
  return request({
    url: "/teachingPlatformService/api/app/testing/getUserTestingSurplusInfo",
    method: "post",
    data: params
  });
}

/**
 * 根据测评试卷id查询试卷
 * @param params
 * @returns {AxiosPromise}
 */
export function getTestPaperById(params) {
  return request({
    url: "/teachingPlatformService/api/app/testing/getTestPaperById",
    method: "post",
    data: params
  });
}

/**
 * 试卷提交
 * @param params
 * @returns {AxiosPromise}
 */
export function submitTestingByUserId(params) {
  return request({
    closeLoading: true,
    url: "/teachingPlatformService/api/app/testing/submitTestingByUserId",
    method: "post",
    data: params
  });
}

/**
 * 试卷结果(id和序号的)
 * @param params
 * @returns {AxiosPromise}
 */
export function getTestingResults(params) {
  return request({
    closeLoading: true,
    url: "/teachingPlatformService/api/app/testing/getTestingResults",
    method: "post",
    data: params
  });
}

/**
 * 试卷结果包含试卷json
 * @param params
 * @returns {AxiosPromise}
 */
export function getTestingJsonArrayResults(params) {
  return request({
    closeLoading: true,
    url: "/teachingPlatformService/api/app/testing/getTestingJsonArrayResults",
    method: "post",
    data: params
  });
}

/**
 * 通过技能标签id获取考场号
 * @param params
 * @returns {AxiosPromise}
 */
export function getTestingNumberByTestPaperNo(params) {
  return request({
    closeInterceptors: true,
    closeLoading: true,
    url:
      "/teachingPlatformService/api/app/testing/getTestingNumberByTestPaperNo",
    method: "post",
    data: params
  });
}

/**
 * 获取试卷分数-考试时候使用
 * @param params
 * @returns {AxiosPromise}
 */
export function apiGetQuestionScoreListForUserExam(params) {
  return request({
    url:
      "/teachingPlatformService/api/app/testing/getQuestionScoreListForUserExam",
    method: "post",
    data: params
  });
}

/**
 * 获取试卷分数-查看成绩时候使用
 * @param params
 * @returns {AxiosPromise}
 */
export function apiGetQuestionScoreListForUserAnswer(params) {
  return request({
    url:
      "/teachingPlatformService/api/app/testing/getQuestionScoreListForUserAnswer",
    method: "post",
    data: params
  });
}
